import { createContext } from "react";

const ScreenContext = createContext();

export default ScreenContext;
